import { contentIsPublished, getAssociatedContentGroups, getContentPropertyValue } from 'content-management-data-lib';
import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
const contentType = 'case-study';
const stripProtocol = url => url.replace(/^(http:\/\/)|(https:\/\/)/, '');
export const getBaseAppUrl = rootSlug => {
  const prefix = enviro.deployed() ? 'app' : 'local';
  const portalId = PortalIdParser.get();
  return `${getFullUrl(prefix)}/${rootSlug}/${portalId}`;
};
export const getDetailsUrl = caseId => {
  return `${getBaseAppUrl(contentType)}/insights/cases/${caseId}/performance`;
};
export const getManageBaseUrl = () => `${getBaseAppUrl(contentType)}/manage`;
export const getManageGroupUrl = groupId => {
  return `${getManageBaseUrl()}/groups/${groupId}/cases`;
};
export const getSettingsUrl = groupId => {
  return `${getBaseAppUrl('settings')}/case-study/groups/${groupId}`;
};
export const getEditorUrl = caseId => `${getBaseAppUrl(contentType)}/editor/${caseId}`;
export const getThemeSettingsEditorUrl = ({
  themeTitle,
  language,
  themePath,
  templatePath
}) => {
  return `${getBaseAppUrl('theme-editor')}/edit/${themePath}?themeTitle=${themeTitle}&fromAppName=caseStudies&redirectUrl=${window.location.pathname}&previewLanguage=${language}&templatePath=${templatePath}`;
};
const getContentAssociatedObjectPropertyValue = (contentObject, property) => {
  var _groups$;
  const groups = getAssociatedContentGroups(contentObject);
  return groups && ((_groups$ = groups[0]) === null || _groups$ === void 0 || (_groups$ = _groups$.properties[property]) === null || _groups$ === void 0 ? void 0 : _groups$.rawValue);
};
export const getLivePageUrl = contentObject => {
  const absoluteUrl = getContentPropertyValue(contentObject, 'hs_absolute_url');
  const previewKey = getContentAssociatedObjectPropertyValue(contentObject, 'hs_preview_key');
  const mainInstanceLayoutPageId = getContentAssociatedObjectPropertyValue(contentObject, 'hs_main_instance_layout_page_id');
  if (contentIsPublished(contentObject) || !previewKey || !mainInstanceLayoutPageId) {
    return absoluteUrl;
  }
  return `https://${stripProtocol(absoluteUrl)}?hs_preview=${previewKey}-${mainInstanceLayoutPageId}`;
};